<div class="backoffice-content">
    <router-outlet></router-outlet>
</div>